import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '../../utils/cn';
import { inputClass } from './Input';

/**
 * Multi-line counterpart to <Input>, carrying the identical surface (border-input,
 * bg-background, shadow, focus ring) so a form mixing the two reads as one control set.
 * Height comes from `rows`, hence min-h rather than the fixed h-9.
 */
export const Textarea = forwardRef<
  HTMLTextAreaElement,
  TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    // h-9 → min-h, and a roomier vertical padding: the only two ways a textarea differs.
    className={cn(inputClass, 'h-auto min-h-[4.5rem] py-2', className)}
    {...props}
  />
));
Textarea.displayName = 'Textarea';
